// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.logonPage {
  background: url("/assets/scss/images/cr-software-bg.jpg") no-repeat center center fixed;
  background-size: cover;
}

#logout-container {
  min-height: 100%;
}

#logon-logo {
  margin-left: auto;
  margin-right: auto;
  width: 600px;
  padding-bottom: 15px;
}

#main-logon-box {
  overflow: auto;
  padding-top: 50px;
}`, "",{"version":3,"sources":["webpack://./src/app/logout/logout.component.scss"],"names":[],"mappings":"AAAA;EACC,uFAAA;EAIA,sBAAA;AACD;;AAEA;EACC,gBAAA;AACD;;AAEA;EACC,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;AACD;;AAEA;EACC,cAAA;EACA,iBAAA;AACD","sourcesContent":["div.logonPage {\n\tbackground: url(\"/assets/scss/images/cr-software-bg.jpg\") no-repeat center center fixed;\n\t-webkit-background-size: cover;\n\t-moz-background-size: cover;\n\t-o-background-size: cover;\n\tbackground-size: cover;\n}\n\n#logout-container {\n\tmin-height: 100%;\n}\n\n#logon-logo {\n\tmargin-left: auto;\n\tmargin-right: auto;\n\twidth: 600px;\n\tpadding-bottom: 15px;\n}\n\n#main-logon-box {\n\toverflow: auto;\n\tpadding-top: 50px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
